<template>
  <div>
    <form
      ref="form"
      @submit.prevent="checkForm"
    >
      <!-- 모달 컨텐츠 -->
      <div class="modal__contents">
        <div class="modal__middlebox">
          <div class="modal__row">
            <h2 class="subtitle subtitle--modal">
              지원 대상 디바이스를 선택 해주세요
            </h2>
          </div>
          <div class="modal__row">
            <div class="formfield">
              <ul class="formfield__row">
                <li
                  v-for="(item, index) in devices"
                  :key="index"
                  class="formfield__inputitem"
                >
                  <div class="checkbox checkbox--border">
                    <input
                      :id="item.name"
                      v-model="req.supportDevice.devices"
                      class="checkbox__input"
                      type="checkbox"
                      name="device"
                      :value="item.value"
                      :disabled="req.supportDevice.tbd"
                    >
                    <label
                      class="checkbox__label checkbox__label--right"
                      :for="item.name"
                    >
                      {{ item.name }}
                    </label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="modal__bottombox">
          <div class="checkbox">
            <input
              id="check"
              v-model="req.supportDevice.tbd"
              class="checkbox__input"
              type="checkbox"
              name="check"
            >
            <label
              class="checkbox__label"
              for="check"
            >
              아직 결정되지 않았습니다.
            </label>
          </div>
        </div>
      </div>
      <!-- 모달 푸터(bottom) -->
      <div class="modal__footer">
        <ul class="modal__buttons">
          <li class="modal__buttonitem">
            <button
              type="button"
              class="button button--large button--secondary"
              @click="save"
            >
              임시저장
            </button>
          </li>
          <li class="modal__buttonitem">
            <button
              type="submit"
              class="button button--large"
              :disabled="!req.supportDevice.tbd && !req.supportDevice.devices.length"
            >
              다음
            </button>
          </li>
        </ul>
      </div>
      <!-- 모달 이전 -->
      <div class="modal__prevbutton">
        <button
          class="button button--function"
          @click="$emit('prev-step')"
        >
          이전
        </button>
      </div>
    </form>
  </div>
</template>
<script>
export default{
  name:'SupportDevice',
  props: {
    request: {
      type: Object,
      required: true
    }
  },
  emits: ['prev-step', 'next-step', 'save-click', 'goto-step'],
  data(){
    return {
      req: this.request,
      devices: [
        {
          name: 'Mobile',
          value: 'MOBILE'
        },
        {
          name: 'PC',
          value: 'PC'
        },
        {
          name: 'Tablet',
          value: 'TABLET'
        },
        // {
        //   name: 'SmartTV',
        //   value: 'SMARTTV'
        // },
        // {
        //   name: 'Kiosk',
        //   value: 'KIOSK'
        // },
      ]
    }
  },
  methods:{
    checkForm() {
      console.log(this.req.supportDevice.devices.length)
      if (this.req.supportDevice.devices.length < 2) {
        this.$emit('goto-step', 'skill')
      } else {
        this.$emit('next-step')
      }
    },
    save() {
      this.$emit('save-click')
    }
  }
}
</script>
<style lang="scss" scoped>
.modal{
  $self:&;
  &__bottom{
    text-align:center;
  }
  &__buttons{
    width:330px;
    margin:0 auto;
    &:after{
      content:'';
      clear:both;
      display:inline;
    }
  }
  &__buttonitem{
    float:left;
    width:160px;
    height:50px;
    &:not(:first-child){
      margin-left:10px;
    }
  }
  &__radiobox{
    margin:0 auto;
    width: 490px;
    margin-top:15px;
  }
}
.formfield{
  &__row{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin: -5px;
  }
  &__inputitem{
    width: calc(20% - 10px);
    margin: 5px;
    height:50px;
    position: relative;
    text-align:left;
  }
}
</style>